export default __webpack_public_path__ + "static/coffee__presentation-c8574a7976988393780389bb0a5fcd15.png";